export default __webpack_public_path__ + "static/media/night-gaac9cc245_1920.e778e866.jpg";